const date_time = {
	day: "day",
	month: "month",
	month_list: [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	],
	year: "year",
};

export default date_time;
